import { MAX_DEFAULT_FIELD_SYMBOLS } from 'constants/general';
import * as yup from 'yup';

export const emailSchema = yup
  .string()
  .email('Invalid email')
  .max(
    MAX_DEFAULT_FIELD_SYMBOLS,
    `Email must not exceed ${MAX_DEFAULT_FIELD_SYMBOLS} characters`
  );
